var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.content,"placement":_vm.placement}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }